/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Change_QInputs */



/**
* | output |
* | --- |
* | "Can I change a customer's plan or add-ons?" |
*
* @param {Partner_Faq_Change_QInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_change_q = /** @type {((inputs?: Partner_Faq_Change_QInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Change_QInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kann ich den Tarif oder die Zusatzpakete eines Kunden ändern?")
	return /** @type {LocalizedString} */ ("Can I change a customer's plan or add-ons?")
});